import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/logo.png';
import './Login.css';

const Login = ({ handleLogin }) => {
    const [email, setEmail] = useState('robinhood@gmail.com');
    const [password, setPassword] = useState('password123');
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="login-page">
            <div className="login-header">
                <Link to="/">
                    <img src={logo} alt="Psyche Gate logo" className="login-logo" />
                </Link>
            </div>
            <div className="login-container">
                <div className="login-card">
                    <h2>Log in to Psyche Gate</h2>

                    <div className="form-group">
                        <label htmlFor="email">EMAIL</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <div className="label-row">
                            <label htmlFor="password">PASSWORD</label>
                            <a href="#!" className="forgot-password">Forgot your password?</a>
                        </div>
                        <div className="password-input-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button type="button" className="toggle-password" onClick={togglePasswordVisibility}>
                                {showPassword ? 'Hide' : 'Show'}
                            </button>
                        </div>
                    </div>

                    <button className="btn-continue" onClick={handleLogin}>Continue</button>

                </div>
            </div>
        </div>
    );
};

export default Login;